<template>
  <BCard
    v-if="groupClassDetails"
    header-class="text-center w-100 d-block p-1"
    class="w-100"
    border-variant="primary"
    header="جزئیات کلاس"
    header-bg-variant="primary"
    header-text-variant="white"
    align="center"
  >
    <BRow class="w-100 mt-2">
      <BCol cols="6" class="text-left">
        <p dir="ltr">:تاریخ کلاس</p>
      </BCol>
      <BCol cols="6" class="text-right">
        <p class="font-weight-bolder">
          {{
            groupClassDetails.startDate
              ? customFullDateConvert(groupClassDetails.startDate)
              : "-"
          }}
        </p>
      </BCol>

      <BCol cols="6" class="text-left">
        <p dir="ltr">:ساعت شروع</p>
      </BCol>
      <BCol cols="6" class="text-right">
        <p class="font-weight-bolder">
          {{
            groupClassDetails.startDate
              ? customConvertHourAndMinute(groupClassDetails.startDate)
              : "-"
          }}
        </p>
      </BCol>

      <BCol cols="6" class="text-left">
        <p dir="ltr">:ساعت پایان</p>
      </BCol>
      <BCol cols="6" class="text-right">
        <p class="font-weight-bolder">
          {{
            groupClassDetails.endDate
              ? customConvertHourAndMinute(groupClassDetails.endDate)
              : "-"
          }}
        </p>
      </BCol>
    </BRow>
  </BCard>
</template>

<script>
export default {
  props: {
    groupClassDetails: {
      type: Object,
      required: true,
    },
  },
  mixins: [timeConvertUtils],
  components: {
    BRow,
    BCol,
    BCard,
  },
};
import timeConvertUtils from "@/mixins/timeConvertUtils";
import { BRow, BCol, BCard } from "bootstrap-vue";
</script>
